import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "box-column full-height" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "box-row items-center q-px-md q-py-sm" }
const _hoisted_4 = {
  key: 0,
  class: "header row items-center"
}
const _hoisted_5 = {
  key: 0,
  class: "text-h4 q-pr-md"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = {
  key: 0,
  class: "full-height flex column items-center justify-center"
}
const _hoisted_8 = { class: "q-pb-md" }
const _hoisted_9 = { class: "q-pa-sm" }

import { ref, computed, watch, onMounted } from "vue";
  import { useMeta, Platform } from "quasar";

  import { useProposalStore } from "src/stores/proposal-store";
  import { useSettingsStore } from "src/stores/settings-store";

  import DealsheetDetailsForm from "src/components/form/forms/DealsheetDetailsForm.vue";
  import DropdownSelectButton from "src/components/form/buttons/DropdownSelectButton.vue";
  import ApplicationFilter from "src/components/form/filters/ApplicationFilter.vue";
  import AppCreateButton from "src/components/form/buttons/AppCreateButton.vue";
  import PipelineView from "src/components/customer/views/PipelineView.vue";
  import ListView from "src/components/customer/views/ListView.vue";
  import ApplicationFilters from "src/types/controls/application-filters";
  
  import { LoanApplication } from "src/types/loan-application/index";
  import { QuickQuote } from "src/types/quote/index";
  import { LoanStatusType_Enum } from "src/types/enums/index";
  import { useCapitalise, useDifferenceInMinutes, useDifferenceInDays, useMapQuickQuoteToLoanApplication } from "src/functions";

  import { GetMetadata } from "src/factories";
  import { useAuthStore } from "../../stores/auth-store";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomersPage',
  setup(__props) {

  const proposalStore = useProposalStore();
  const settingsStore = useSettingsStore();
  const authStore = useAuthStore();

  const isMobile = computed(() => settingsStore.isMobile);

  const defaultFilters = settingsStore.defaultCustomerFilters

  const filters = ref<ApplicationFilters>(settingsStore.customerFilters)

  onMounted(() => {
    if (isMobile.value) {
      view.value = "list";
    }
    proposalStore.clearStockProposal();
    getData();
  })

  const applications = computed(() => proposalStore.applications);
  const filteredApplications = computed(() => {
    
    let f = Object.assign([], applications.value) as LoanApplication[];
    if (filters.value.text && filters.value.text !== "") {
      f = f.filter(i =>
        (i.customer && (i.customer.firstName.toLowerCase().replace(" ", "") + i.customer.lastName.toLowerCase().replace(" ", "")).includes(filters.value.text!.toLowerCase().replace(" ", ""))) ||
        (i.vehicle && ((i.vehicle.make ? i.vehicle.make.toLowerCase().replace(" ", "") : '') + (i.vehicle.model ? i.vehicle.model.toLowerCase().replace(" ", "") : '')).includes(filters.value.text!.toLowerCase().replace(" ", ""))) ||
        (i.vehicle && i.vehicle.vehicleRegistration && i.vehicle.vehicleRegistration.toLowerCase().replace(" ", "").includes(filters.value.text!.toLowerCase().replace(" ", ""))) ||
        (authStore.selectedDealers &&
          Number(i.affiliateUserId) === (
          authStore.selectedDealers.find(d => d.name.toLowerCase().replace(" ", "").includes(filters.value.text!.toLowerCase().replace(" ", ""))) ?
            authStore.selectedDealers.find(d => d.name.toLowerCase().replace(" ", "").includes(filters.value.text!.toLowerCase().replace(" ", "")))!.affiliateUserId :
            -1)
        )
      )
    }
    if (filters.value.decision && filters.value.decision.length > 0) {
      f = f.filter(i =>  filters.value.decision!.find(d => d === decisionStatus(i).label))
    }

    if (filters.value.status && filters.value.status.length > 0) {
      f = f.filter(i => filters.value.status!.includes(i.state))
    }

    if (filters.value.createdBy && filters.value.createdBy.length > 0) {
      f = f.filter(i => filters.value.createdBy!.find(u => i.createdBy.includes(u)));
    }
    return f;
  })


  function vehicleValid(application: LoanApplication) {

    if ([
      LoanStatusType_Enum["NTU Rate Too High"],
      LoanStatusType_Enum["NTU Lost To Competitor"],
      LoanStatusType_Enum["NTU Outside Criteria"],
      LoanStatusType_Enum["NTU Other"],
    ].includes(application.state)) {
      return 0;
    }

    if (!application || !application.vehicle || application.isQuickQuote) {
      return 0;
    }

    if (!application || !application.proposals || application.proposals.length === 0) {
      return 0;
    }

    if (application.vehicle && application.vehicle.cannotPrice) {
      return 2;
    }

    return 3;
  }

  function decisionStatus(application: LoanApplication) {

    // Complete
    if (application.state === LoanStatusType_Enum.Completed) {
      return {
        label: "Completed",
        colour: "bg-positive text-white"
      };
    }

    // NTU 
    if ([
      LoanStatusType_Enum["NTU Rate Too High"],
      LoanStatusType_Enum["NTU Lost To Competitor"],
      LoanStatusType_Enum["NTU Outside Criteria"],
      LoanStatusType_Enum["NTU Other"]
    ].includes(application.state)) {
      return {
        label: `${LoanStatusType_Enum[application.state]}`,
        colour: "bg-warning text-dark"
      };
    }

    // Expired
    if (useDifferenceInDays(application.created, new Date()) > 45) {
      return {
        label: "Proposals Expired",
        colour: "bg-warning text-dark"
      };
    }

    if (application.proposals && application.proposals.length > 0) {

      // Approved / Vehicle Failed
      if (application.proposals.find(p => p.loanProposalStatus && p.loanProposalStatus.toString() === 'Accepted')) {
        const vv = vehicleValid(application);
        return {
          label: [3, 0].includes(vv) ? "Approved" : "Failed Vehicle Rule",
          colour: [3, 0].includes(vv) ? "bg-positive text-white" : "bg-warning text-dark"
        }
      }

      // Provisional Approval / Vehicle Failed
      if (application.proposals.find(p => p.loanProposalStatus && p.loanProposalStatus.toString() === 'ProvisionalAcceptance' && (!p.customerRuleResults || (p.customerRuleResults && p.customerRuleResults.find(r => r.resultType === "FixedDecline"))))) {
        const vv = vehicleValid(application);
        return {
          label: [3, 0].includes(vv) ? "Approved (Predicted)" : "Failed Vehicle Rule",
          colour: [3, 0].includes(vv) ? "bg-positive  text-white" : "bg-warning text-dark"
        }
      }

      // Conditional Approval / Vehicle Failed
      if (application.proposals.find(p => p.loanProposalStatus && p.loanProposalStatus.toString() === 'ConditionallyAccepted' && (!p.customerRuleResults || (p.customerRuleResults && p.customerRuleResults.find(r => r.resultType === "FixedDecline"))))) {
        const vv = vehicleValid(application);
        return {
          label: [3, 0].includes(vv) ? "Approved (Conditionally)" : "Failed Vehicle Rule",
          colour: [3, 0].includes(vv) ? "bg-positive  text-white" : "bg-warning text-dark"
        }
      }

      // Processing
      if (application.proposals.find(p => p.loanProposalStatus && p.loanProposalStatus.toString() === 'Processing')) {
        return {
          label: "Awaiting Decision",
          colour: "bg-warning"
        }
      }

      // Declined
      if (application.proposals.find(p => p.loanProposalStatus && p.loanProposalStatus.toString() === 'Declined') ||
      application.proposals.find(p => (p.customerRuleResults && p.customerRuleResults.find(r => r.resultType === 'FixedDecline')) || (p.loanProposalStatus && p.loanProposalStatus.toString() === 'FailedSendRules'))) {
        return {
          label: "Declined",
          colour: "bg-negative text-white"
        }
      }
    }
    else {
      // App just created
      if (useDifferenceInMinutes(new Date(application.created), new Date()) < 15) {
        return {
          label: "Awaiting Decision",
          colour: "bg-warning text-dark"
        };
      }

    }

    return {
      label: "",
      colour: "bg-warning text-dark"
    };
  }

  const quickQuotes = computed(() => {
    const uids = [...new Set(proposalStore.quickQuotes.map(item => item.quickQuoteId))];

    return uids.map(i => proposalStore.quickQuotes.find(f => f.quickQuoteId === i)).map(m => useMapQuickQuoteToLoanApplication(m!))
  });

  const filteredQuickQuotes = computed(() => {
    let f = Object.assign([], quickQuotes.value) as LoanApplication[];
    if (filters.value.text && filters.value.text !== "") {
      f = f.filter(i =>
        (i.customer && (i.customer.firstName.toLowerCase().replace(" ", "") + i.customer.lastName.toLowerCase().replace(" ", "")).includes(filters.value.text!.toLowerCase().replace(" ", ""))) ||
        ((i.vehicle.make.toLowerCase().replace(" ", "") + i.vehicle.model.toLowerCase().replace(" ", "")).includes(filters.value.text!.toLowerCase().replace(" ", ""))) ||
        (i.vehicle && i.vehicle.vehicleRegistration && i.vehicle.vehicleRegistration.toLowerCase().replace(" ", "").includes(filters.value.text!.toLowerCase().replace(" ", ""))) ||
        (authStore.selectedDealers &&
          Number(i.affiliateUserId) === (
            authStore.selectedDealers.find(d => d.name.toLowerCase().replace(" ", "").includes(filters.value.text!.toLowerCase().replace(" ", ""))) ?
              authStore.selectedDealers.find(d => d.name.toLowerCase().replace(" ", "").includes(filters.value.text!.toLowerCase().replace(" ", "")))!.affiliateUserId :
              -1)
        )
      )
    }
    if (filters.value.decision && filters.value.decision.length > 0) {
      return [];
    }
    if (filters.value.status && filters.value.status.length > 0 && !filters.value.status.find(d => d === -1)) {
      return [];
    }
    if (filters.value.date > 0) {
      f = f.filter(i => useDifferenceInDays(new Date(i.created), new Date()) <= filters.value.date)
    }
    if (filters.value.createdBy && filters.value.createdBy.length > 0) {
      f = f.filter(i => filters.value.createdBy!.includes(i.createdBy));
    }
    return f.sort((a, b) => new Date(a.created).getTime() < new Date(b.created).getTime() ? 1 : -1);
  })

  const view = ref(settingsStore.selectedCustomerView);
  watch(() => view.value, () => {
    settingsStore.updateCustomerView(view.value);
    useMeta(GetMetadata({
      title: useCapitalise(view.value) + ' view',
      description: "",
      keywords: "",
      ogUrl: `${process.env.UiBaseUrl}/customer`,
      isSearchable: false,
    }))
  })
  const viewOptions = ref([
    { name: "Pipeline View", value: "pipeline", icon: "mdi-view-column-outline" },
    { name: "List View", value: "list", icon: "mdi-view-list-outline" }]
  )

  const searching = computed(() => {
    return filters.value.decision !== defaultFilters.decision ||
      filters.value.status !== defaultFilters.status ||
      filters.value.createdBy !== defaultFilters.createdBy ||
      filters.value.text !== defaultFilters.text
  })

  watch(() => filters.value.date, () => {
    getData()
  })
  const isLoading = ref(false);
  const isLoadingQuickQuotes = ref(false);

  function getData() {
    if (proposalStore.applications.length === 0) {
      isLoading.value = true;
    }
    if (proposalStore.quickQuotes.length === 0) {
      isLoadingQuickQuotes.value = true;
    }
    proposalStore.getApplications(filters.value.date).finally(() => {
      isLoading.value = false;
      settingsStore.updateTimeOfLastPoll(new Date());
    });
    proposalStore.getQuickQuotes(filters.value.date).finally(() => {
      isLoadingQuickQuotes.value = false;
    });
  }

  function myFilterFn(url: string) {
    // example (only https://my-service.com/* should trigger)
    return  /https:\/\/apim-customer-prod\.azure-api\.net\/api\/dealer\/v1\/application/i.test(url) || /https:\/\/apim-customer-dev\.azure-api\.net\/api\/dealer\/v1\/application/i.test(url)
  }

  useMeta(GetMetadata({
    title: useCapitalise(view.value) + ' view',
    description: "",
    keywords: "",
    ogUrl: `${process.env.UiBaseUrl}/customer`,
    isSearchable: false,
  }))

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_ajax_bar = _resolveComponent("q-ajax-bar")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "full-height" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!isMobile.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (!_unref(Platform).is.ipad)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Customers"))
                    : _createCommentVNode("", true),
                  (!isMobile.value)
                    ? (_openBlock(), _createBlock(AppCreateButton, {
                        key: 1,
                        compact: false
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(["", isMobile.value ? 'full-width' : 'flex justify-end'])
              }, [
                (!isMobile.value)
                  ? (_openBlock(), _createBlock(DropdownSelectButton, {
                      key: 0,
                      options: viewOptions.value,
                      modelValue: view.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((view).value = $event)),
                      colour: "primary"
                    }, null, 8, ["options", "modelValue"]))
                  : _createCommentVNode("", true),
                (!isMobile.value)
                  ? (_openBlock(), _createBlock(_component_q_separator, {
                      key: 1,
                      vertical: "",
                      class: "q-my-sm q-mx-sm"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(ApplicationFilter, { filters: filters.value }, null, 8, ["filters"])
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["content", isMobile.value ? 'overflow-auto' : 'overflow-hidden'])
        }, [
          _createElementVNode("div", null, [
            _createVNode(_component_q_separator),
            _createVNode(_component_q_ajax_bar, {
              "hijack-filter": myFilterFn,
              class: "relative-position",
              color: "primary"
            })
          ]),
          ((!applications.value || applications.value.length === 0) && (!quickQuotes.value || quickQuotes.value.length === 0))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_q_img, {
                    src: require('assets/img/smile_grey.svg'),
                    width: "120px",
                    class: "q-mx-auto"
                  }, null, 8, ["src"])
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-h5" }, " No Customers ", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-body2" }, " Create a new quick quote or proposal to get started. ", -1)),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(AppCreateButton, { compact: false })
                ])
              ]))
            : (_openBlock(), _createBlock(_component_q_tab_panels, {
                key: 1,
                modelValue: view.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((view).value = $event)),
                animated: "",
                "transition-prev": "fade",
                "transition-next": "fade",
                class: "full-height"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tab_panel, {
                    name: "pipeline",
                    style: {"width":"unset !important"},
                    class: "brand-app-bg"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(PipelineView, {
                        applications: filteredApplications.value,
                        quickQuotes: filteredQuickQuotes.value,
                        searching: searching.value,
                        isLoading: isLoading.value,
                        isLoadingQQ: isLoadingQuickQuotes.value
                      }, null, 8, ["applications", "quickQuotes", "searching", "isLoading", "isLoadingQQ"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_q_tab_panel, {
                    name: "list",
                    class: "brand-app-bg q-py-xs-none q-py-sm-md"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ListView, {
                        applications: filteredApplications.value,
                        quickQuotes: filteredQuickQuotes.value
                      }, null, 8, ["applications", "quickQuotes"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
        ], 2)
      ])
    ]),
    _: 1
  }))
}
}

})